module.exports = __webpack_public_path__ + "static/img/07.9e3f5d75.png";